module.exports = __webpack_public_path__ + "static/OpenGraph_TBH-4ae70377de9b3bf0f718ed8bac84d3f0.jpg";